import { createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("main", {
      class: _normalizeClass(_ctx.$style.container)
    }, [
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.$style.searchbar)
      }, [
        _createVNode($setup["SearchBar"], {
          "search-text": $setup.searchText,
          "onUpdate:search-text": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchText) = $event)),
          matchFound: !$setup.items.find((i) => i.content.toLowerCase() === $setup.searchText.toLowerCase()),
          onSubmit: $setup.submit
        }, null, 8, ["search-text", "matchFound"])
      ], 2),
      _createElementVNode("section", {
        class: _normalizeClass(_ctx.$style.list)
      }, [
        _createVNode($setup["List"], {
          results: $setup.search($setup.searchText),
          highlight: $setup.items.find((i) => i.content.toLowerCase() === $setup.searchText.toLowerCase())?.id,
          onDeleteItem: _cache[1] || (_cache[1] = (id) => $setup.removeItemById(id))
        }, null, 8, ["results", "highlight"])
      ], 2),
      _createElementVNode("aside", {
        class: _normalizeClass(_ctx.$style.options)
      }, [
        _createVNode($setup["SearchOptions"], {
          options: $setup.options,
          onSelectOption: $setup.setSearchOptions
        }, null, 8, ["options"])
      ], 2)
    ], 2)
  ]))
}